import { useEffect, useState } from "react";
import "./advertisingPopup.scss";
import popupBackgroundDefaultImage from "../../../../assets/images/default-popup-background.png";
import { useHistory } from "react-router-dom";
import { HyperlinkType } from "../../../../../constants/hyperlink-type.constants";
import FnbModal from "../../../../components/fnb-modal/fnb-modal";
import { CloseDialog } from "../../../../assets/icons.constants";
import { getStoreConfig, handleHyperlinkValue } from "../../../../../utils/helpers";
import discountCodeDataService from "../../../../../data-services/discount-code-data.service";
import { DiscountCodeDetailComponent } from "../../../../components/discount-code-detail-component/discount-code-detail.component";

export default function AdvertisingPopupComponent(props) {
  const [isShowAdvertising, setIsShowAdvertising] = useState(false);
  const { clickToFocusCustomize, isCustomize, config, general } = props;
  const advertisingPopupConfig = config?.advertisingPopup?.visible;
  const history = useHistory();
  const popupConfigs = config?.advertisingPopup;
  const banner = popupConfigs?.banner;
  const popupLink = popupConfigs?.popupLink;
  const [isOpenDiscountCodeDetail, setIsOpenDiscountCodeDetail] = useState(false);
  const [discountCodeDetail, setDiscountCodeDetail] = useState(null);
  const promotionSection = props?.config?.promotionSection;
  const generalCustomization = promotionSection?.generalCustomization;
  const colorConfig = general?.color?.colorGroups?.find((c) => c?.id === generalCustomization?.colorGroupId) ?? null;

  useEffect(() => {
    if (isCustomize) {
      setIsShowAdvertising(advertisingPopupConfig);
    } else {
      let isClosed = sessionStorage.getItem("isClosedPopup");
      if (!isClosed) {
        setIsShowAdvertising(advertisingPopupConfig);
      }
    }
  }, [advertisingPopupConfig]);

  let styleBackground = {};
  styleBackground = {
    backgroundImage: `url(${banner?.backgroundImage ?? popupBackgroundDefaultImage})`,
    backgroundAttachment: "initial",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  const showDiscountCodeDetail = async (promotionId) => {
    const storeConfig = getStoreConfig();
    const discountCodeDetail = await discountCodeDataService.getDiscountCodeDetailByIdAsync(
      storeConfig?.storeId,
      promotionId,
    );
    if (discountCodeDetail?.data?.discountCode) {
      setIsOpenDiscountCodeDetail(true);
      setDiscountCodeDetail(discountCodeDetail?.data?.discountCode);
    }
  };

  const handleCloseDiscountCodeDetail = () => {
    // hiddenDiscount && hiddenDiscount(false);
    setIsOpenDiscountCodeDetail(false);
  };

  const onCloseAdvertisingPopup = () => {
    setIsShowAdvertising(false);
    sessionStorage.setItem("isClosedPopup", 1);
  }

  return (
    <>
      <FnbModal
        className={"adPopup"}
        open={isShowAdvertising}
        onCancel={() => onCloseAdvertisingPopup()}
        footer={null}
        getContainer={() => {
          return document.getElementById("right-content");
        }}
        closable={true}
        // centered
        closeIcon={<CloseDialog />}
        children={
          <div
            className="advertising-banner"
            style={styleBackground}
            onClick={() => {
              if (!isCustomize) {
                const hyperlink = handleHyperlinkValue(popupLink?.hyperlinkType, popupLink?.hyperlinkValue);
                if (popupLink?.hyperlinkType === HyperlinkType.PROMOTION_DETAIL) {
                  showDiscountCodeDetail(popupLink?.hyperlinkValue);
                } else if (hyperlink) {
                  history.push(hyperlink);
                }
                onCloseAdvertisingPopup();
              }
            }}
          />
        }
        isCustomize={isCustomize}
      />
      <DiscountCodeDetailComponent
        discountCodeDetail={discountCodeDetail}
        isOpenDiscountCodeDetail={isOpenDiscountCodeDetail}
        handleCancel={handleCloseDiscountCodeDetail}
        colorConfig={colorConfig}
      />
    </>
  );
}
